import { FILEMETA_SPLIT_CHARACTER } from "@pdfking/constants/settings"
import filter from "rfuncs/functions/filter"
import merge from "rfuncs/functions/merge"

import type { FileData } from "../types/FileData"
import append_slash from "./append_slash"

export default (...filedata: FileData[]): string => {
  const merged = merge(...filedata)
  const basename =
    filter(
      s => (s ? s.length > 0 : false),
      [merged.basename, merged.uuid]
    ).join(FILEMETA_SPLIT_CHARACTER) + (merged.ext ? `.${merged.ext}` : "")

  if (merged.folder) {
    return append_slash(merged.folder) + basename
  }

  return basename
}
